/**
 * Знак метро — буква «М» в круге, как на указателях. Иконка вагона
 * `Subway` из набора читалась как поезд вообще, а не как метро
 */
const MetroMark = () => (
  <span
    aria-hidden="true"
    className="flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-action font-display text-on-action"
    style={{ fontSize: 12, fontWeight: 800, lineHeight: 1 }}
  >
    М
  </span>
);

export default MetroMark;
